import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { storage, db, auth } from '../Firebase/Firebase.js';
import { getFirestore, setDoc, doc, getDoc, collection, query, where, getDocs, addDoc, updateDoc } from 'firebase/firestore';
import './PlataformaReserva.css';
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import FloatingWhatsApp from '../Components/whatsappbutton.js';
import LoadingScreen from '../Components/loading.js';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import QRCodeGenerator from '../Components/QRcodeGenerator.js';

export default function DetalleEspacio() {
    const { IdEspacio } = useParams();
    const navigate = useNavigate();
    const [espacio, setEspacio] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fechaSeleccionada, setFechaSeleccionada] = useState('');
    const [horasDisponibles, setHorasDisponibles] = useState([]);
    const [horaInicio, setHoraInicio] = useState('');
    const [horaFin, setHoraFin] = useState('');
    const [bloqueos, setBloqueos] = useState([]);
    const [resenas, setResenas] = useState([]);
    const [qrCodeModalIsOpen, setQrCodeModalIsOpen] = useState(false);
    const [usuario, setUsuario] = useState(null);
    const [costoTotal, setCostoTotal] = useState(0);

    useEffect(() => {
        // Obtener el usuario actual logueado
        const user = auth.currentUser;
        if (user) {
            async function fetchUsuario() {
                const userRef = doc(db, 'usuarios', user.uid);
                const docSnap = await getDoc(userRef);
                if (docSnap.exists()) {
                    setUsuario({ id: docSnap.id, ...docSnap.data() });
                }
            } fetchUsuario();
        }

    }, []);

    useEffect(() => {
        async function fetchEspacio() {
            const ref = doc(db, 'espacios', IdEspacio);
            const snap = await getDoc(ref);
            if (snap.exists()) {
                console.log(snap.data());
                setEspacio({ IdEspacio, ...snap.data() });
            }
        }
        fetchEspacio();
    }, [IdEspacio]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (espacio?.Imagenes?.length) {
                setCurrentIndex((prev) => (prev + 1) % espacio.Imagenes.length);
            }
        }, 5000);
        return () => clearInterval(interval);
    }, [espacio]);

    useEffect(() => {
        if (!fechaSeleccionada || !espacio) return;

        const obtenerReservas = async () => {
            const q = query(
                collection(db, 'reservas'),
                where('IdEspacio', '==', espacio.IdEspacio),
                where('fechaInicio', '==', fechaSeleccionada)
            );
            const querySnapshot = await getDocs(q);

            const rangos = querySnapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    inicio: data.horaInicio,
                    fin: data.horaFinal
                };
            });
            setBloqueos(rangos);
        };

        obtenerReservas();
    }, [fechaSeleccionada, espacio]);

    useEffect(() => {
        const obtenerResenas = async () => {
            if (!espacio) return;
            const q = query(
                collection(db, 'reseñas'),
                where('idEspacio', '==', espacio.IdEspacio)
            );
            const querySnapshot = await getDocs(q);
            const data = querySnapshot.docs.map(doc => doc.data());
            setResenas(data);
        };
        obtenerResenas();
    }, [espacio]);

    const seleccionarHora = (hora) => {

        if (!horaInicio || (horaInicio && horaFin)) {
            setHoraInicio(hora);
            setHoraFin('');

        } else if (hora > horaInicio) {
            setHoraFin(hora);

        } else {
            setHoraInicio(hora);
            setHoraFin('');

        }

    };
    useEffect(() => {
        if (horaInicio && horaFin) { // Aquí verificamos si "algo" tiene un valor
            calcularCosto();
        }
    }, [horaInicio, horaFin]);

    const estaOcupada = (hora) => {
        return bloqueos.some(({ inicio, fin }) => hora >= inicio && hora < fin);
    };

    const estaEnRango = (hora) => {
        return horaInicio && horaFin && hora >= horaInicio && hora <= horaFin;
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % espacio.Imagenes.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - 1 + espacio.Imagenes.length) % espacio.Imagenes.length);
    };

    const getVisibleImages = () => {
        if (!espacio) return [];
        const total = espacio.Imagenes.length;
        const prev = (currentIndex - 1 + total) % total;
        const next = (currentIndex + 1) % total;
        return [prev, currentIndex, next];
    };

    const generarHoras = () => {
        if (!espacio?.horaApertura || !espacio?.horaCierre) return [];
        const inicio = parseInt(espacio.horaApertura.split(":")[0]);
        const fin = parseInt(espacio.horaCierre.split(":")[0]);
        const horas = [];
        for (let h = inicio; h <= fin; h++) {
            const hora = h.toString().padStart(2, '0') + ':00';
            horas.push(hora);
        }
        return horas;
    };

    // Función de reserva
    const reservar = async () => {
        calcularCosto();
        if (!usuario) {
            // Muestra el Toast solo si el usuario no está logueado
            toast.error(
                <div style={{ padding: '10px 20px', color: '#fff', fontSize: '16px' }}>
                    <p style={{ margin: 0, fontWeight: 'bold' }}>¡Ops! Necesitas loguearte para realizar una reserva.</p>
                    <button
                        onClick={handleLogin}
                        style={{
                            padding: '12px 25px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '15px',
                            cursor: 'pointer',
                            marginTop: '10px',
                            fontSize: '16px',
                            boxShadow: '0 4px 6px rgba(0, 123, 255, 0.2)',
                            transition: 'background-color 0.3s ease, transform 0.3s ease',
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                    >
                        Ingresar
                    </button>
                </div>,
                {
                    position: "top-center",
                    autoClose: 8000,  // Se cierra automáticamente después de 8 segundos
                    closeOnClick: true, // Se puede cerrar con clic
                    draggable: true,
                    theme: "colored",

                    style: {
                        backgroundColor: '#fbbf24', // Rojo para un mensaje de error
                        color: '#ffffff', // Blanco para el texto
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        marginTop: '35px',
                    },
                }
            );

        } else {
            if (usuario.coins < costoTotal) {
                console.log('Coins insuficientes');
                toast.error(
                    <div style={{ padding: '10px 20px', color: '#fff', fontSize: '16px' }}>
                        <p style={{ margin: 0, fontWeight: 'bold', color: '#fff', fontSize: '16px' }}>
                            ¡Ups! 😕 Tu saldo de <strong>coins</strong> es insuficiente para completar la reserva.
                            La reserva de tu espacio tienen un costo de
                            <strong style={{ color: '#f4f4f4' }}>{` ${costoTotal} coins`}</strong>.<br />
                            ¡Recarga tu saldo y disfruta de tu experiencia!
                        </p>
                        <button
                            onClick={handleRecargarCoins}
                            style={{
                                padding: '12px 25px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '15px',
                                cursor: 'pointer',
                                marginTop: '10px',
                                fontSize: '16px',
                                boxShadow: '0 4px 6px rgba(0, 123, 255, 0.2)',
                                transition: 'background-color 0.3s ease, transform 0.3s ease',
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                        >
                            Recargar
                        </button>
                    </div>,
                    {
                        position: "top-center",
                        autoClose: 8000,  // Se cierra automáticamente después de 8 segundos
                        closeOnClick: true, // Se puede cerrar con clic
                        draggable: true,
                        theme: "colored",

                        style: {
                            backgroundColor: '#fbbf24', // Rojo para un mensaje de error
                            color: '#ffffff', // Blanco para el texto
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            marginTop: '35px',
                        },
                    }
                );
            } else {
                guardarReserva();
            }
        }



        // Si el usuario está logueado, continuar con la reserva
        try {
            // Lógica de reserva aquí
        } catch (error) {
            console.error("Error al realizar la reserva:", error);
        }
    };
    const calcularCosto = () => {
        if (horaInicio && horaFin) {
            const inicio = new Date(`1970-01-01T${horaInicio}:00`); // Convertir hora de inicio a objeto Date
            const fin = new Date(`1970-01-01T${horaFin}:00`); // Convertir hora de fin a objeto Date
            const diferenciaEnMilisegundos = fin - inicio; // Diferencia en milisegundos
            const diferenciaEnHoras = diferenciaEnMilisegundos / (1000 * 60 * 60); // Convertir milisegundos a horas
            const costo = diferenciaEnHoras * espacio.costoEspHoraCoins; // Calcular el costo total
            setCostoTotal(costo); // Actualizar el costo total
        }
    };
    // Función para redirigir al login
    const handleLogin = () => {
        localStorage.setItem('reservation', 'true');
        localStorage.setItem('reservationUrl', window.location.href);
        navigate('/login');  // Cambia esta ruta a la ruta de tu login
    };

    const handleRecargarCoins = () => {
        localStorage.setItem('reservationCoins', 'true');
        localStorage.setItem('reservationCoinsUrl', window.location.href);
        navigate('/portal-recargas');
    };

    const guardarReserva = async () => {
        const reservationData = {
            fechaInicio: fechaSeleccionada,
            horaInicio: horaInicio,
            horaFinal: horaFin,
            costoReserva: costoTotal,
            idUser: usuario.id,
            IdEspacio: espacio.IdEspacio,
            reseñaRealizada: false,
            calUsers: false,
            fechaDeReserva: new Date(),
        };
        try {
            const userRef = doc(db, 'usuarios', usuario.id);
            await updateDoc(userRef, {
                coins: usuario.coins - costoTotal,
            });
            await addDoc(collection(db, 'reservas'), reservationData);
            toast.success(
                <div style={{ padding: '15px 25px', color: '#fff', fontSize: '18px', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontWeight: 'bold', color: 'black', fontSize: '18px' }}>
                        🎉 ¡Reserva Confirmada! 🎉
                        <br />
                        ¡Felicidades! Tu espacio está reservado con éxito.
                        <br />
                        ¡Prepárate para disfrutar de la mejor experiencia!
                    </p>
                    <button
                        onClick={setQrCodeModalIsOpen(true)}
                        style={{
                            padding: '12px 30px',
                            backgroundColor: '#c7ffc0',
                            color: 'black',
                            border: 'none',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            marginTop: '15px',
                            fontSize: '16px',
                            boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                            transition: 'background-color 0.3s ease, transform 0.3s ease',
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#badfb6'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#d4ffcf'}
                    >
                        ¡Empecemos !
                    </button>
                </div>,
                {
                    position: "top-center",
                    autoClose: 8000,  // Se cierra automáticamente después de 8 segundos
                    closeOnClick: true, // Se puede cerrar con clic
                    draggable: true,
                    theme: "colored",
                    style: {
                        backgroundColor: '#d9f6d5', // Verde brillante para éxito
                        color: '#ffffff', // Blanco para el texto
                        borderRadius: '12px',
                        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)',
                        marginTop: '35px',
                    },
                    onClose: () => {
                        setQrCodeModalIsOpen(true); // Esta es la acción que se ejecuta cuando el toast se cierra
                    }
                }
            );

        } catch (error) {
            console.error("Error al guardar la reserva:", error);
        }
    }

    useEffect(() => {
        if (fechaSeleccionada) {
            setHorasDisponibles(generarHoras());
        }
    }, [fechaSeleccionada, espacio]);

    if (!espacio) return <LoadingScreen />;

    return (
        <>
            <Navbar />
            <FloatingWhatsApp />
            <ToastContainer /> {/* Aquí se coloca el ToastContainer para que se rendericen los toasts */}

            <div className="espacio-container">
                <div className="espacio-header">
                    <h1 className="espacio-titulo">{espacio.NombreEspacio}</h1>
                    <p className="espacio-subtitulo">{espacio.categoriaEspacio} · Capacidad {espacio.CapacidadMin} - {espacio.CapacidadMax} personas</p>
                </div>



                <div className="espacio-carrusel-multiple">
                    <button className="carrusel-btn carrusel-prev" onClick={handlePrev}>‹</button>
                    <div className="carrusel-center">
                        {getVisibleImages().map((i, index) => (
                            <div key={i} className={`carrusel-item-multi ${index === 1 ? 'active' : 'side'}`}>
                                <img src={espacio.Imagenes[i]} alt={`Imagen ${i + 1}`} className="espacio-img-multiple" />
                            </div>
                        ))}
                    </div>
                    <button className="carrusel-btn carrusel-next" onClick={handleNext}>›</button>
                </div>

                <div className="espacio-content2">
                    {/* Detalles del espacio */}
                    <div className="espacio-info-detalle" style={{
                        borderColor: `${espacio.Color}`,
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        boxShadow: `0 4px 8px rgba(0, 0, 0, 0.1)`
                    }}>                        <p><strong>Accesorios:</strong> {espacio.Accesorios}</p>
                        <p><strong>Descripción:</strong> {espacio.DescripcionEspacio}</p>

                    </div>


                    <div className="reserva-sticky">
                        <div className="reserva-card">
                            <h3>Selecciona fecha y horario</h3>
                            <div className="reserva-fechas">
                                <div>
                                    <label>FECHA</label>
                                    <input
                                        type="date"
                                        value={fechaSeleccionada}
                                        min={new Date().toISOString().split('T')[0]}
                                        onChange={(e) => {
                                            const hoy = new Date().toISOString().split('T')[0];
                                            const valor = e.target.value;
                                            setFechaSeleccionada(valor < hoy ? hoy : valor);
                                        }}
                                    />
                                </div>
                            </div>
                            {horasDisponibles.length > 0 && (
                                <div className="reserva-horas">
                                    <label>HORARIO DISPONIBLE</label>
                                    <div className="horas-scroll">
                                        {horasDisponibles.map((hora, idx) => {
                                            const activo = hora === horaInicio || hora === horaFin;
                                            const enRango = estaEnRango(hora);
                                            const esHoy = fechaSeleccionada === new Date().toISOString().split('T')[0];
                                            const ahora = new Date();
                                            const horaObj = new Date(`${fechaSeleccionada}T${hora}`);
                                            const esPasada = esHoy && horaObj <= ahora;
                                            const ocupada = estaOcupada(hora);
                                            const bloquear = esPasada || ocupada;

                                            return (
                                                <div
                                                    key={idx}
                                                    className={`hora-bloque ${activo ? 'activo' : ''} ${enRango ? 'rango' : ''} ${bloquear ? 'bloqueada' : ''}`}
                                                    onClick={() => {
                                                        if (!bloquear) seleccionarHora(hora);
                                                    }}
                                                    style={{ pointerEvents: bloquear ? 'none' : 'auto' }}
                                                >
                                                    {hora}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            {
                                espacio.descuentoXPersona && (<div className="reserva-huespedes">
                                    <label>USUARIOS</label>
                                    <select>
                                        {Array.from({ length: espacio.CapacidadMax }, (_, i) => (
                                            <option key={i}>{i + 1} usuario{i !== 0 ? 's' : ''}</option>
                                        ))}
                                    </select>
                                </div>)
                            }
                            {
                                <div>
                                    {fechaSeleccionada && horaInicio && horaFin && (
                                        <div className="reserva-huespedes">
                                            Reserva para el día {fechaSeleccionada} de {horaInicio} a {horaFin}
                                        </div>
                                    )}
                                </div>

                            }
                            <button className="reservar-btn-full" onClick={reservar} disabled={!fechaSeleccionada}>Reservar</button>
                        </div>
                    </div>
                </div>

                <div className="espacio-mapa">
                    <iframe
                        title="mapa"
                        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyB7Sx1jXG9YS5c7Iy-qxOEfkECMh7syeqg&q=${espacio.latitud},${espacio.longitud}`}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

                {resenas.length > 0 && (
                    <div className="resenas-section">
                        <h2>★ {(
                            resenas.reduce((sum, r) => sum + r.calificacion, 0) / resenas.length
                        ).toFixed(2)} · {resenas.length} reseñas</h2>

                        <div className="resena-resumen">
                            <div className="resena-categoria">
                                <p>Valoración general</p>
                                <span>5</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Limpieza</p>
                                <span>5.0</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Exactitud</p>
                                <span>5.0</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Check-in</p>
                                <span>4.9</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Comunicación</p>
                                <span>4.8</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Ubicación</p>
                                <span>4.9</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Precio</p>
                                <span>4.6</span>
                            </div>
                        </div>

                        <div className="resenas-list">
                            {resenas.map((res, idx) => (
                                <div className="resena-item" key={idx}>
                                    <div className="resena-usuario">
                                        <img src={res.foto} alt="Usuario" />
                                        <div>
                                            <strong>{res.nombreUsuario}</strong>
                                        </div>
                                    </div>
                                    <p className="resena-calificacion">{'★'.repeat(res.calificacion)}</p>
                                    <p className="resena-texto">{res.Reseña}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {usuario && (
                <QRCodeGenerator
                    isOpen={qrCodeModalIsOpen}
                    onClose={() => {
                        setQrCodeModalIsOpen(false);
                        navigate('/reservasRealizadas');
                    }}
                    userName={`${usuario.name} ${usuario.lastname}`}
                    espacio={espacio?.NombreEspacio ?? ''}
                    reservationDate={fechaSeleccionada}
                    startTime={horaInicio}
                    endTime={horaFin}
                />
            )}

            <Footer />
        </>
    );
}
